export default "__VITE_ASSET__21f4b786__"